export const registerDict = {
    "en": {
        "phoneTitle": "Phone number must be 10 digits",
        "passwordTitle": "Password must be 8-20 characters long and include at least one special character",
        "validationMessage": "Please match the requested format",
        "email_required": "Please Enter Correct Email ID",
        "acceptance_required": "Acceptance is required.",
        "correct_email_format" : "Please ensure the email is in the correct format: user@example.com",
        "password_required" : "Password is Required"
    },
    "hi": {
        "phoneTitle": "फोन नंबर 10 पॉइंटं का होना चाहिए",
        "passwordTitle": "पासवर्ड 8-20 वर्णों का होना चाहिए और कम से कम एक विशेष चरित्र शामिल होना चाहिए",
        "validationMessage": "कृपया अनुरोधित प्रारूप से मेल खाएं",
        "email_required": "कृपया सही ईमेल आईडी दर्ज करें।",
        "acceptance_required": "स्वीकृति आवश्यक है।",
        "correct_email_format" : "कृपया सुनिश्चित करें कि ईमेल सही प्रारूप में हो",
        "password_required" : "पासवर्ड की आवश्यकता है"
    },
    "jp": {
        "phoneTitle": "電話番号は10桁で入力してください",
        "passwordTitle": "パスワードは8〜20文字で、特殊文字を1つ以上含める必要があります",
        "validationMessage": "指定された形式に合わせて入力してください",
        "email_required": "正しいメールアドレスをご入力ください",
        "acceptance_required": "同意が必要です。",
        "correct_email_format" : "メールアドレスを正しい形式でご入力ください: user@example.com",
        "password_required" : "パスワードが必要です"
    }
};
